var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.67c-.19 0-.38-.07-.53-.22L.95 10.93a2.74 2.74 0 0 1 0-3.86L7.47.55c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L2.01 8.13c-.48.48-.48 1.26 0 1.74l6.52 6.52c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22Z"
  })));
};
export default SvgChevronLeft;